declare global {
  interface String {
    normalize(): string;
    capitalize(): string;
    trim(): string;
  }
}

export class StringAugmentation {
  static init() {
    String.prototype.normalize = function () {
      const value = String(this);
      const from = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç';
      const to = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc';
      const mapping = {};

      for (let i = 0, j = from.length; i < j; i++) {
        mapping[from.charAt(i)] = to.charAt(i);
      }

      const ret = [];
      for (let i = 0, j = value.length; i < j; i++) {
        const c = value.charAt(i);
        if (mapping.hasOwnProperty(value.charAt(i))) {
          ret.push(mapping[c]);
        } else {
          ret.push(c);
        }
      }
      return ret.join('');
    };

    String.prototype.capitalize = function () {
      const value = String(this).toLowerCase();
      return value.replace(/(?:^|\s)\S/g, function (a) {
        return a.toUpperCase();
      });
    };
    String.prototype.trim = function () {
      return this ? this.replace(/^\s+|\s+$/g, '') : '';
    };
  }
}
